import { PortalConfig } from "../types/config";

// Mock configuration data
const mockConfig: PortalConfig = {
  logoUrl: "/images/nbtx.png", //"/images/logo.png",
  primaryColor: "#2489A6", // 1d4ed8 Default blue-600
  maxVehicles: 3,
  permitTypes: [
    {
      id: "daily",
      label: "Daily Pass",
      price: 10.0,
      description: "24-hour parking permit",
      durationDays: 1,
    },
    {
      id: "weekly",
      label: "Weekly Pass",
      price: 50.0,
      description: "7-day parking permit",
      durationDays: 7,
    },
    {
      id: "monthly",
      label: "Monthly Pass",
      price: 150.0,
      description: "30-day parking permit",
      durationDays: 30,
    },
    {
      id: "annual",
      label: "Annual Pass",
      price: 1500.0,
      description: "365-day parking permit",
      durationDays: 365,
    },
  ],
  recaptcha: {
    enabled: true,
    siteKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", // This is Google's test key
  },
  mandatoryFields: {
    personalInfo: {
      firstName: true,
      lastName: true,
      email: true,
      phone: false,
    },
    vehicleDetails: {
      make: true,
      model: true,
      color: false,
    },
  },
  documents: {
    enabled: true,
    requirements: [
      {
        id: "drivers_license",
        name: "Driver's License",
        description: "A valid driver's license showing your current address",
        required: true,
        acceptedFormats: [".jpg", ".jpeg", ".png", ".pdf"],
        maxSizeMB: 5,
      },
      {
        id: "proof_of_residence",
        name: "Proof of Residence",
        description:
          "Recent utility bill (water, electric, gas) or lease agreement dated within last 60 days",
        required: true,
        acceptedFormats: [".jpg", ".jpeg", ".png", ".pdf"],
        maxSizeMB: 5,
      },
      {
        id: "vehicle_registration",
        name: "Vehicle Registration",
        description: "Current vehicle registration document",
        required: false,
        acceptedFormats: [".jpg", ".jpeg", ".png", ".pdf"],
        maxSizeMB: 5,
      },
    ],
  },
};

export const getPortalConfig = async (): Promise<PortalConfig> => {
  // Simulate API call delay
  await new Promise((resolve) => setTimeout(resolve, 1000));
  return mockConfig;
};
